import { render, staticRenderFns } from "./Disconnected.vue?vue&type=template&id=064e1452&"
import script from "./Disconnected.vue?vue&type=script&lang=js&"
export * from "./Disconnected.vue?vue&type=script&lang=js&"
import style0 from "./Disconnected.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports